export default "__VITE_ASSET__DoXptFzI__"